import {
  PASSWORD_POLICIES_LIST_CHARACTER,
  PASSWORD_POLICIES_MIN_NUMBERS_CHARACTERS,
  PASSWORD_POLICIES_NUMBER_OF_CHARACTERS,
  PASSWORD_POLICIES_NUMBER_OF_LOWER_CASE_CHARACTERS,
  PASSWORD_POLICIES_NUMBER_OF_SPECIAL_CHARACTERS,
  PASSWORD_POLICIES_NUMBER_OF_UPPER_CASE_CHARACTERS,
  PASSWORD_POLICIES_TITLE,
} from '../../constants/ui.labels'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import Flex from '@talkdesk/cobalt-react-flex'

const PasswordPolicies = ({ isError = false, passwordPolicies }) => {
  passwordPolicies = passwordPolicies || {}
  const theme = useTheme()
  const renderParagraph = (text) =>
    isError ? (
      <Text>{PASSWORD_POLICIES_LIST_CHARACTER.concat(text)}</Text>
    ) : (
      <Text inline size='small' color={theme.gray600}>
        {text}
      </Text>
    )

  return (
    <Flex
      direction='column'
      paddingY='2'
      paddingInlineStart={isError ? undefined : '6'}
      gap='2'
    >
      {isError ? <Text>{PASSWORD_POLICIES_TITLE}</Text> : null}
      {renderParagraph(
        PASSWORD_POLICIES_NUMBER_OF_CHARACTERS(passwordPolicies.minLength),
      )}
      {renderParagraph(
        PASSWORD_POLICIES_NUMBER_OF_UPPER_CASE_CHARACTERS(
          passwordPolicies.minUpper,
        ),
      )}
      {renderParagraph(
        PASSWORD_POLICIES_NUMBER_OF_LOWER_CASE_CHARACTERS(
          passwordPolicies.minLower,
        ),
      )}
      {renderParagraph(
        PASSWORD_POLICIES_MIN_NUMBERS_CHARACTERS(passwordPolicies.minDigits),
      )}
      {renderParagraph(
        PASSWORD_POLICIES_NUMBER_OF_SPECIAL_CHARACTERS(
          passwordPolicies.minSpecial,
        ),
      )}
    </Flex>
  )
}

export default PasswordPolicies
